import { LOGIN_TOKEN, PARCEIRO_DATA, SSE_VALUE, SSE_VALUEEnd } from 'domain/types/authentication/authentication';
import { AuthenticationService } from 'domain/services/authentication/authenticationService'
import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils';
import { _UserData, UserDataBaseEnum } from '../../../infra/storage/localStorage';
import { UsuarioResponse } from 'domain/types/usuario/usuarioResponse';
import { AppThunk } from '../../../utils/reducerUtil';
import { ParceiroService } from 'domain/services/parceiro/parceiroService';
import { SSEOptions, StreamMessage } from 'domain/infra/data/api';
import { GetUsuarioSistemaPerfil } from '../../usuarioSistemaPerfil/action/usuarioSistemaPerfilAction';
// import { StateType } from 'domain/types/base/base';


const _AuthenticationService = new AuthenticationService();
const _ParceiroService = new ParceiroService();

export function ParceiroByUrl(url: string): AppThunk {
	return async (dispatch) => {
		const asyncResponse = await _ParceiroService.GetByUrl(url);

		if (ResponseValid(asyncResponse)) {

			dispatch({
				payload: asyncResponse,
				type: PARCEIRO_DATA
			});

		}
	};
}

export function LoginByToken(token?: string | null, reportError: boolean = true): AppThunk {
	return async (dispatch) => {
		const _userData = _UserData;

		if (token == null || token == "") {
			_userData.Clear();
			dispatch({
				payload: false,
				type: LOGIN_TOKEN
			});
			if (reportError) dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.ERROR));
			return;
		}

		dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.LOADING));

		const asyncResponse = await _AuthenticationService.LoginByToken(token);

		if (ResponseValid(asyncResponse)) {

			const Usuario = asyncResponse as UsuarioResponse;
			_userData.Register(Usuario);
			dispatch(GetUsuarioSistemaPerfil(Usuario.UsuarioID));

			dispatch({
				payload: true,
				type: LOGIN_TOKEN
			});

		} else {
			_userData.LogOut();

			dispatch({
				payload: false,
				type: LOGIN_TOKEN
			});

			if (reportError) dispatch(DispatchLoading(LOGIN_TOKEN, DispatchType.ERROR, (asyncResponse as Error).message));
		}
	};
}

export function CheckHasLogin(logOut: boolean): AppThunk {
	return async (dispatch) => {
		function handleOut() {
			_UserData.Clear();

			dispatch({
				payload: false,
				type: LOGIN_TOKEN
			});
		}

		if (logOut) {
			handleOut();
			return null;
		}

		//Ainda não implementado corretamente
		// const manterConectado = _UserData.Get<boolean>(UserDataBaseEnum.ManterConectado);
		// if(manterConectado == false){
		//     handleOut();
		//     return
		// }

		const token = _UserData.Get<string>(UserDataBaseEnum.Token);
		if (token != null) {
			dispatch({
				payload: true,
				type: LOGIN_TOKEN
			});
			LoginByToken(token);
		}
	};
}


//TODO REMOVER
// eslint-disable-next-line no-unused-vars
export function TestSSE(onError: (event: Event) => void, onOpen: () => void, onMessage: (data: StreamMessage<number>) => void): AppThunk {
	return async (/*dispatch*/) => {

		const options: SSEOptions<number> = {
			dispatchName: SSE_VALUE,
			onError: onError,
			onMessage: onMessage,
			onOpen: onOpen,
		}

		//options?.dispatchName && dispatch(DispatchLoading(SSE_VALUEEnd, DispatchType.LOADING, "SSE", StateType.Master))

		/*const asyncResponse =*/ await _AuthenticationService.TestSSE<string, number>("aa", SSE_VALUEEnd, options)

		/*if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: SSE_VALUEEnd
			});
			return asyncResponse;
		}*/

	}
}
